import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InfoMessages } from 'apps/driver-dashboardfe/src/app/shared/constants/info-messages.constant';
import { DialogHandlerService } from '../../services/dialog-handler/dialog-handler.service';
import { JoinService } from '../../services/join/join.service';

@Component({
    standalone: false,
    selector: 'octo-tos-dialog',
    templateUrl: './tos-dialog.component.html',
    styleUrls: ['./tos-dialog.component.scss'],
})
export class TosDialogComponent {
    isTosForm: boolean = false;

    constructor(
        private modalRef: MatDialogRef<TosDialogComponent>,
        private dialogService: DialogHandlerService,
        private joinService: JoinService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        modalRef.disableClose = false;
        this.data === 'tosForm'
            ? (this.isTosForm = true)
            : (this.isTosForm = false);
    }

    showTermsModal(): void {
        this.dialogService.showTermsModal('service').subscribe({});
    }

    acceptTos(): void {
        localStorage.setItem('isTosAccepted', 'true');
        const driverStatus = localStorage.getItem('status');
        if (driverStatus === 'approved') {
            this.joinService.updateDriverStatus().subscribe(() => {
                localStorage.setItem('status', 'tos_complete');
            });
        }
        this.modalRef.close({
            isTosAccepted: true,
        });
    }
}
